import { createContext } from 'react';

export type AppEnvironment = 'Production' | 'NonProduction';

export const EnvironmentContext = createContext<AppEnvironment | null>(null);
EnvironmentContext.displayName = 'EnvironmenContext';
